import React, { useContext } from 'react'
import { Embed } from '../../components/Embed'
import { useGetMetabaseSignedUrl } from '../../utils'
import { DeviceContext } from './DeviceContext'

export const DeviceMetabase = () => {
    const deviceContext = useContext(DeviceContext)
    const { data } = useGetMetabaseSignedUrl(
        576,
        {
            device_uuid: [deviceContext.selectedDevice?.uuid],
            date_range: 'past168hours-from-4hours'
        },
        !Boolean(deviceContext.selectedDevice?.uuid && deviceContext.deviceStations?.[0]?.station_name)
    )

    if (!data?.metabase_url) return <>Loading</>
    return (
        <div>
            <Embed height="2500px" url={data.metabase_url} />
        </div>
    )
}
